module.exports = __webpack_public_path__ + "img/copyLink.f8d57535.png";